/* Nutrilight "Alla produkter" overview (sections/nl-shop-overview.liquid)
   - keeps the sticky category chips just below the theme's sticky header (which hides on scroll down)
   - highlights the chip of the group in view and keeps it visible in the horizontal rail
     (round 7: position based, so the rail resets at the top and below the last group)
   - "Visa alla" toggles for long groups on mobile
   - gentle reveal of groups (skipped with prefers-reduced-motion; nothing is hidden without JS) */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.nlsInit) return;
    root.dataset.nlsInit = '1';

    var nav = root.querySelector('[data-nls-nav]');
    var rail = root.querySelector('[data-nls-rail]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-nls-chip]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-nls-group]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* 1. Sticky offset follows the theme header */
    var header = document.querySelector('.header-section');
    function syncTop() {
      var top = 0;
      if (header) {
        var cs = getComputedStyle(header);
        var sticky = cs.position === 'sticky' || cs.position === 'fixed';
        var hidden = header.classList.contains('header-hidden');
        if (sticky && !hidden) {
          top = Math.round(header.offsetHeight + (parseFloat(cs.top) || 0));
        }
      }
      root.style.setProperty('--nls-top', top + 'px');
    }
    syncTop();
    if (header && 'MutationObserver' in window) {
      new MutationObserver(function () { requestAnimationFrame(syncTop); }).observe(header, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', syncTop, { passive: true });

    /* Shadow under the chip bar once it is stuck */
    if (nav && 'IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'height:1px;margin-bottom:-1px';
      nav.parentNode.insertBefore(sentinel, nav);
      new IntersectionObserver(function (e) {
        nav.classList.toggle('is-stuck', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(sentinel);
    }

    /* Edge fades on the chip rail when it scrolls */
    function syncRail() {
      if (!rail) return;
      var over = rail.scrollWidth > rail.clientWidth + 2;
      var atStart = rail.scrollLeft < 4;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      rail.classList.toggle('is-overflow', over && !atStart && !atEnd);
      rail.classList.toggle('is-start', over && atStart);
      rail.classList.toggle('is-end', over && atEnd && !atStart);
    }
    if (rail) {
      rail.addEventListener('scroll', function () { requestAnimationFrame(syncRail); }, { passive: true });
      window.addEventListener('resize', syncRail, { passive: true });
      syncRail();
    }

    /* 2. Active chip */
    var byId = {};
    chips.forEach(function (c) { byId[c.getAttribute('data-nls-chip')] = c; });
    var current = null;
    function setActive(id) {
      if (id === current) return;
      current = id;
      chips.forEach(function (c) {
        var on = c.getAttribute('data-nls-chip') === id;
        c.classList.toggle('is-active', on);
        if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      var chip = byId[id];
      if (chip && rail && rail.scrollWidth > rail.clientWidth) {
        var left = chip.offsetLeft - (rail.clientWidth - chip.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    /* Position based, so it also resets when the visitor jumps straight back to the top
       (an IntersectionObserver gets no event when nothing was in view before or after the jump) */
    if (groups.length) {
      var ticking = false;
      var zone = 'above';
      function spy() {
        ticking = false;
        var line = window.innerHeight * 0.4;
        var id = null;
        for (var i = 0; i < groups.length; i++) {
          var r = groups[i].getBoundingClientRect();
          if (r.top <= line && r.bottom > line) { id = groups[i].getAttribute('data-nls-group'); break; }
        }
        if (id !== null) { zone = 'in'; setActive(id); return; }
        if (groups[0].getBoundingClientRect().top > line) {
          /* back above the first group: clear the chip and bring the rail back to its start once */
          setActive(null);
          if (zone !== 'above' && rail) rail.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
          zone = 'above';
        } else if (groups[groups.length - 1].getBoundingClientRect().bottom <= line) {
          setActive(null);
          zone = 'below';
        }
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(spy); }
      }, { passive: true });
      spy();
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { setActive(c.getAttribute('data-nls-chip')); });
    });

    /* 3. "Visa alla" on mobile */
    Array.prototype.forEach.call(root.querySelectorAll('[data-nls-more]'), function (btn) {
      var wrap = btn.closest('.nls-group__wrap');
      var list = wrap && wrap.querySelector('[data-nls-limit]');
      if (!list) return;
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        list.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        btn.parentNode.hidden = true;
        var first = list.querySelector('.nls-extra a');
        if (first) first.focus({ preventScroll: true });
      });
    });

    /* 4. Reveal */
    if (!reduce && 'IntersectionObserver' in window) {
      var targets = root.querySelectorAll('.nls-group__head, .nls-best__item, .nls-grid__item, .nls-list__in');
      Array.prototype.forEach.call(targets, function (t) {
        var r = t.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.95) return; /* already on screen: leave as is */
        t.setAttribute('data-nls-reveal', '');
      });
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      Array.prototype.forEach.call(root.querySelectorAll('[data-nls-reveal]'), function (t) { rio.observe(t); });
    }
    root.classList.add('is-ready');
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-nls]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
